import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

export default createStore('spacesSearchResultsStore', {
    searchInitialized: false,
    loading: 0, // count of currently in-progress searches
    searchResults: new ObservableMap<string, ObservableMap<string, SearchResultItem>>(), // map entity -> item id -> searchResult
    searchTerms: [] as string[],
    error: null as string,
    isManualSearch: false,
});
